/**
 * Vehicle damage record category values
 */
export enum VehicleDamageRecordCategoryEnum {
	VEHICLE = 'vehicle',
	RENTAL_AGREEMENT = 'rental_agreement',
}
